import axios from 'axios';
import { clearStoredSession, getStoredToken } from '../utils/authStorage.js';
import { resolveAuthenticatedHeaders } from '@/utils/requestContext.js';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'https://api.sinamonsoft.ar',
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 15000,
});

api.interceptors.request.use(
  (config) => {
    try {
      const headers = resolveAuthenticatedHeaders();
      Object.entries(headers).forEach(([key, value]) => {
        config.headers[key] = value;
      });
    } catch (error) {
      console.warn('Error al configurar tenant header:', error);
      const token = getStoredToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    // Receipt-only guard must not be swallowed by the legacy auth fallback above.
    config.receiptOperationGuard?.(config.headers);
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      const { config } = error;
      const silentAuthFailure = config?.skipAuthRedirect === true;

      switch (status) {
        case 401:
          console.warn('Solicitud no autorizada:', data?.message || 'Token invalido o expirado');

          if (!silentAuthFailure) {
            clearStoredSession();

            if (!window.location.pathname.includes('/login')) {
              window.location.assign('/login');
            }
          }
          break;

        case 403:
          console.warn('Acceso denegado:', data?.message || 'Sin permisos');
          break;

        case 500:
          console.error('Error del servidor:', data?.message || 'Error interno');
          break;

        default:
          console.error('Error en la peticion:', status, data);
      }
    } else if (error.request) {
      console.error('No se recibio respuesta del servidor');
    } else {
      console.error('Error al configurar la peticion:', error.message);
    }

    return Promise.reject(error);
  },
);

export default api;
